import React, {useState} from 'react';
import '../css/home.css';
import { Link } from 'react-router-dom';

import { useWeb3Modal } from '@web3modal/wagmi/react';
import { useAccount, useContract, useBalance, useConnect, useDisconnect } from 'wagmi';
import { InjectedConnector } from 'wagmi/connectors/injected';

const BuyPage = () => {
    const {open} = useWeb3Modal();
    const {address, isConnected} = useAccount();
    const {connect} = useConnect({
      connector: new InjectedConnector({ supportedChainIds: [1, 4, 5, 42, 137, 80001] }),
    })
    const {disconnect} = useDisconnect();

    // if address, then change shorten it to 0x...0000
    const shortenedAddress = address ? `${address.slice(0, 6)}...${address.slice(-4)}` : null;

  return (
    <div className='buy-page'>
        <div className='navbar'>
          <img src='https://i.ibb.co/ZVXyHrj/Screenshot-2023-10-02-183910.png'/>
          <div className='button navbar-right' onClick={isConnected ? disconnect : connect}>{isConnected ? shortenedAddress : 'Connect'}</div>
        </div>
        <div className='grid'>
          <div className='flex'>
            <div className='semi-heading'>
              Upload a high detail image of your front face with clean background and following the correct face ratio and resolution. 
            </div>
            <div>
              <div className='button'>
                Upload Image
              </div>
              <Link to="/done">
                <div className='button'>
                  Next
                </div>
              </Link>
            </div>
          </div>
          <img className='image' src='https://i.ibb.co/D4hKNdN/Screenshot-2023-10-02-134856.png' alt='tron' />
        </div>
    </div>
  )
}

export default BuyPage;
